module.exports = __webpack_public_path__ + "img/banner-bg.5e1f95e7.jpg";